var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "addNewAppModal",
    attrs: {
      id: "new-application-modal",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "md",
      "header-close-button": "",
      "footer-close-button": false,
    },
    on: { hide: _vm.resetModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_vm._v(_vm._s(_vm.$t("global.actions.startNewApplication")))]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.page === "select"
              ? _c("b-col", [
                  _c("p", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "global.messages.clientPortalStartNewApplication"
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.options.length > 1
                    ? _c(
                        "div",
                        [
                          _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "global.actions.selectAgentClientPortal"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              id: "brokerage-dropdown",
                              options: _vm.options,
                            },
                            on: { change: _vm.handleChangeOption },
                            model: {
                              value: _vm.selectedOption,
                              callback: function ($$v) {
                                _vm.selectedOption = $$v
                              },
                              expression: "selectedOption",
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "global.actions.youAreSendingApplicationTo"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            staticClass: "text-black",
                            attrs: {
                              disabled: "",
                              value: _vm.options[0].text,
                              type: "text",
                            },
                          }),
                        ],
                        1
                      ),
                ])
              : _c(
                  "b-col",
                  [
                    _c("checkbox-section", {
                      attrs: {
                        label: _vm.$t(
                          "global.phrases.confirmStartingNewApplication",
                          {
                            selectedBroker: _vm.selectedBroker,
                            selectedBrokerage: _vm.selectedBrokerage,
                          }
                        ),
                        checked: _vm.confirm,
                      },
                      model: {
                        value: _vm.confirm,
                        callback: function ($$v) {
                          _vm.confirm = $$v
                        },
                        expression: "confirm",
                      },
                    }),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _vm.page === "select"
              ? _c(
                  "div",
                  { attrs: { id: "btn-container" } },
                  [
                    _c(
                      "simple-button",
                      {
                        staticClass: "confirm",
                        attrs: { disabled: _vm.$v.$invalid },
                        on: {
                          click: function ($event) {
                            _vm.page = "confirm"
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("global.words.nextPage")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "w-100", attrs: { id: "btn-container" } },
                  [
                    _c(
                      "b-row",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "auto" } },
                          [
                            _c("simple-button", {
                              staticClass: "order-1",
                              attrs: {
                                id: "back",
                                text: "Back",
                                type: "white",
                              },
                              on: {
                                click: function () {
                                  _vm.page = "select"
                                  _vm.confirm = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "auto" } },
                          [
                            _c(
                              "simple-button",
                              {
                                staticClass: "confirm",
                                attrs: {
                                  disabled: !_vm.confirm,
                                  loading: _vm.loading,
                                },
                                on: { click: _vm.handleCreateApplication },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("global.words.sendApplication")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }